import apiClient from "../../../utilities/apiClient";
import { ROLES, ADMIN_ROLES } from "../../../utilities/roles";

import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";

export const get_AdminInvoices = (payload) => {
  const role = LocalStorage.getItem(SESSION_KEY).roles;
  return apiClient.get(
    //Todo fix permissions
    role[0] === ROLES.ADMIN || role[0] === ROLES.FINANCE
      ? `${apiClient.Urls.admin_invoice_lists}`
      : `${apiClient.Urls.officer_invoices_list}`,
    payload,
    true
  );
};

export const view_InvoiceDetails = (payload) => {
  const role = LocalStorage.getItem(SESSION_KEY).roles;
  return apiClient.get(
    //Todo fix permissions
    role[0] === ROLES.ADMIN || role[0] === ROLES.FINANCE
      ? `${apiClient.Urls.admin_invoice_view}/${payload}`
      : role[0] === ROLES.USER
      ? `${apiClient.Urls.view_user_invoice_details}/${payload}`
      : `${apiClient.Urls.view_invoice_details}/${payload}`,
    "",
    true
  );
};

export const approve_invoice = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.invoice_approve}/${payload.invoice_id}`,
    payload,
    true
  );
};
